import { call, put } from "redux-saga/effects";
import { planConstants } from "../actions/constants/planConstants";
import { planService } from "../services/planService";
import { commonActions } from "../actions/commonAction";
import { commonConstants } from "@/actions/constants/commonConstants";

function* listPlans(action: any): any {
    try {
        const response = yield call(planService.listPlans, action.payload);
        if (response.success) {
            yield put({ type: planConstants.listPlansSuccess, payload: response.resultObject });
        } else {
            yield put({ type: planConstants.listPlanFailure, payload: response.message || response.errorMessage });

            yield put(commonActions.errorResponse(response.message || "Failed to fetch subscription plans"));
        }
    } catch (error) {
        yield put({ type: planConstants.listPlanFailure, payload: error });
    }
}

function* createPlan(action: any): any {
    try {
        const response = yield call(planService.createPlan, action.payload);
        if (response.success) {
            yield put({ type: planConstants.createPlanSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message })
        } else {
            yield put({ type: planConstants.createPlanFailure, payload: response.message || response.errorMessage });

            yield put(commonActions.errorResponse(response.errorMessage || "Failed to create subscription plan"));
        }
    } catch (error) {
        yield put({ type: planConstants.createPlanFailure, payload: error });
    }
}

function* viewPlan(action: any): any {
    try {
        const response = yield call(planService.viewPlan, action.payload);
        if (response.success) {
            yield put({ type: planConstants.viewPlanSuccess, payload: response.resultObject });
        } else {
            yield put({ type: planConstants.viewPlanFailure, payload: response.message || response.errorMessage });

            yield put(commonActions.errorResponse(response.message || "Failed to view subscription plan"));
        }
    } catch (error) {
        yield put({ type: planConstants.viewPlanFailure, payload: error });
    }
}

function* updatePlan(action: any): any {
    try {
        const response = yield call(planService.updatePlan, action.payload);
        if (response.success) {
            yield put({ type: planConstants.updatePlanSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message })
        } else {
            yield put({ type: planConstants.updatePlanFailure, payload: response.message || response.errorMessage });

            yield put(commonActions.errorResponse(response.message || "Failed to update subscription plan"));
        }
    } catch (error) {
        yield put({ type: planConstants.updatePlanFailure, payload: error });
    }
}


export const planSaga = {
    listPlans,createPlan,viewPlan,updatePlan
};